import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class AccessLedgerService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getAccessLedger(startId, endId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/access-ledger`, authenticatedApiConfig(this.authenticationProvider, { startId, endId }));
        response.data.forEach((record) => (record.timestamp = new Date(Date.parse(record.timestamp))));
        return response.data;
    }
    async getAccessLedgerCount() {
        const response = await axios.get(`${this.environment.API_BASE_URL}/access-ledger/count`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async postSearchAccessLedger(input, start, end) {
        const body = { ...input };
        if (body.timestampStart)
            body.timestampStart = body.timestampStart.toISOString();
        if (body.timestampEnd)
            body.timestampEnd = body.timestampEnd.toISOString();
        const response = await axios.post(`${this.environment.API_BASE_URL}/access-ledger/search`, body, authenticatedApiConfig(this.authenticationProvider, { start, end }));
        response.data.results.forEach((record) => (record.timestamp = new Date(Date.parse(record.timestamp))));
        return response.data;
    }
}
